import { Component, OnInit } from '@angular/core';
import { VendorService } from '../../services/vendor.service';


@Component(
  {
    selector: 'app-vendor-profile',
    templateUrl: './vendor-profile.component.html'
  })
export class VendorProfileComponent implements OnInit {
  vendor: any = null;
  editing = false;
  message = '';


  constructor(private vendorService: VendorService) { }


  ngOnInit(): void {
    this.load();
  }


  load() {
    this.vendorService.getMyProfile().subscribe(v => this.vendor = v);
  }


  save() {
    this.vendorService.updateProfile(this.vendor).subscribe(() => {
      this.message = 'Saved';
      this.editing = false;
      this.load();
    });
  }

}
